import { render } from "./FormContainer.vue?vue&type=template&id=5b30bac0&scoped=true"
import script from "./FormContainer.vue?vue&type=script&lang=js"
export * from "./FormContainer.vue?vue&type=script&lang=js"

import "./FormContainer.vue?vue&type=style&index=0&id=5b30bac0&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b30bac0"]])

export default __exports__